import React from 'react'
import { ImageIcon } from '@/icon'
import { Card, Button } from '@mui/material'
import { styled, SxProps } from '@mui/material/styles'
import account_bg from '@/asset/img/account_bg.webp'
import verify_icon from '@/asset/img/verify_icon.webp'

export const BasicCard = styled(Card, {
  shouldForwardProp: (prop) => prop !== 'view',
})<{ view: 'info' | 'form' }>(({ view = 'info' }) => ({
  padding: '32px 48px',
  display: 'flex',
  backgroundImage: `url(${view === 'info' ? account_bg : ''})`,
  backgroundPositionX: 'right',
  backgroundPositionY: 'bottom',
  justifyContent: view === 'info' ? 'flex-start' : 'center',
  backgroundSize: '40%',
  backgroundRepeat: 'no-repeat',
  alignItems: 'stretch',
  gap: '5%',
}))

export const QRCard = styled(Card)(() => ({
  padding: '24px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
}))

export const CardTopAction = styled('div')(() => ({
  display: 'flex',
  width: '100%',
  justifyContent: 'flex-end',
}))

export const Icon = ({ sx }: { sx?: SxProps }) => {
  return <ImageIcon sx={sx} src={verify_icon} />
}

export const Footer = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '24px',
}))

export const List = styled('ul')(() => ({
  margin: '16px 0',
  listStyle: 'disc',
  li: {
    marginLeft: '5%',
  },
}))

export const Extra = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '24px',
  marginTop: '24px',
}))

export const ValidationButton = styled(Button)`
  background: #eff0f0;
  line-height: 16px;
  text-align: center;
  color: #344767;
  letter-spacing: 1px;
  margin-top: 0 !important;
`
